import React from "react";

const Header = () => {
  return <div className="header">Personal Shopping List</div>;
};

export default Header;
